import {z} from 'zod';

export const MAX_REQUEST_PARAM_LENGTH = 24;

export const requestParamsValidator = z.object({
    key: z
        .string()
        .min(1, 'presEditPage.settings.requestParameters.tooShort')
        .max(MAX_REQUEST_PARAM_LENGTH, 'presEditPage.settings.requestParameters.tooLong'),
    required: z.boolean(),
});
